/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaboratorselectedfunds3Inputs */

const en_settings_collaborators_invitecollaboratorselectedfunds3 = /** @type {(inputs: Settings_Collaborators_Invitecollaboratorselectedfunds3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SELECTED FUNDS`)
};

/**
* | output |
* | --- |
* | "SELECTED FUNDS" |
*
* @param {Settings_Collaborators_Invitecollaboratorselectedfunds3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaboratorselectedfunds3 = /** @type {((inputs?: Settings_Collaborators_Invitecollaboratorselectedfunds3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaboratorselectedfunds3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaboratorselectedfunds3(inputs)
});
export { settings_collaborators_invitecollaboratorselectedfunds3 as "settings_collaborators_inviteCollaboratorSelectedFunds" }